
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { BgInputNumber } from "@banggood/scm-fe";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
@Component({
  components: {
    BgInputNumber,
  },
})
export default class OaClothingOemorodm extends SupplierForm {
  form = {
    factoryInfo: {
      developmentInfo: {
        productPriceRange: "",
        newQuantityMonth: null as number | null,
        isForeignFashion: false,
        printingQuantityMonth: null as number | null,
        playVersionTime: null as number | null,
        standaloneRoom: null as number | null,
        independentDesigner: null as number | null,
        independentPrinter: null as number | null,
        carVersion: null as number | null,
      },
    },
  };
  get rules(): ElementUIFormRules {
    return this.getFieldsRules([
      "factoryInfo.developmentInfo.productPriceRange",
      "factoryInfo.developmentInfo.newQuantityMonth",
      "factoryInfo.developmentInfo.isForeignFashion",
      "factoryInfo.developmentInfo.printingQuantityMonth",
      "factoryInfo.developmentInfo.playVersionTime",
      "factoryInfo.developmentInfo.standaloneRoom",
      "factoryInfo.developmentInfo.independentDesigner",
      "factoryInfo.developmentInfo.independentPrinter",
      "factoryInfo.developmentInfo.carVersion",
    ]);
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      ...this.form,
    };
  }
}
